import React, { Component } from 'react';
import './Profile.scss';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import productsActions, { resolveDiscountedPrice } from '../../actions/productsActions';
import userActions from '../../actions/userActions';
import { formatPrice } from '../../utils/CurrencyUtils';
import IonIcon from '@reacticons/ionicons';

const Arrow = () => (
  <svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.923 12.4326C27.5088 11.8469 27.5088 10.8971 26.923 10.3113L17.377 0.76538C16.7912 0.179593 15.8415 0.179593 15.2557 0.76538C14.6699 1.35117 14.6699 2.30091 15.2557 2.8867L23.741 11.372L15.2557 19.8573C14.6699 20.443 14.6699 21.3928 15.2557 21.9786C15.8415 22.5644 16.7912 22.5644 17.377 21.9786L26.923 12.4326ZM0.194642 12.872L25.8623 12.872L25.8623 9.87198L0.194642 9.87198L0.194642 12.872Z"
      fill="white"
    />
  </svg>
);

class SubscriptionDetails extends Component {
  constructor(props) {
    super(props);
    this.state = { packageIds: [3, 4, 7], products: {}, strikethroughs: {} };
  }

  componentDidMount = async () => {
    try {
      const { userId } = this.props;
      const { packageIds } = this.state;
      const {
        profile: { countryCode },
      } = await userActions.getUser(userId);
      const product = await productsActions.getProducts();

      const products = {};
      const strikethroughs = {};
      packageIds.forEach((value) => {
        const pkg = product[value];
        if (!pkg || !pkg.activeCountry[countryCode]) return;
        const price = pkg.price[countryCode];
        const currency = pkg.currency[countryCode];
        products[value] = formatPrice(price, currency);

        // Promotion display: `discountedPrice` is injected by the products API
        // when a promotion is active; checkout auto-applies it server-side.
        const discountedPrice = resolveDiscountedPrice(pkg.discountedPrice, countryCode);
        if (discountedPrice !== undefined) {
          products[value] = formatPrice(discountedPrice, currency);
          strikethroughs[value] = formatPrice(price, currency);
          return;
        }

        const priceMonthly = pkg.priceMonthly ? pkg.priceMonthly[countryCode] : null;
        const months = pkg.prepaidMonths;
        if (priceMonthly && months) {
          const fullPrice = priceMonthly * months;
          if (fullPrice > price) {
            strikethroughs[value] = formatPrice(fullPrice, currency);
          }
        }
      });

      this.setState({ products, strikethroughs });
    } catch (error) {
      console.error(error);
    }
  };

  renderPackage = (packageId, className = '') => {
    const { products, strikethroughs } = this.state;
    if (!products[packageId]) return null;
    const strikethrough = strikethroughs[packageId];
    const tKey = `renewMembership.package${packageId}`;
    return (
      <Link className={`package ${className}`.trim()} to={{ pathname: `/${global.language}/checkout/${packageId}` }}>
        <div className="gradient" />
        {strikethrough && <div className="banner">{i18next.t(`${tKey}.banner`)}</div>}
        <div className="packageContent">
          <div className="packageHeader">
            <h4>{i18next.t(`${tKey}.title`)}</h4>
            <p dangerouslySetInnerHTML={{ __html: i18next.t(`${tKey}.text`) }} />
          </div>
          <div className="packageFooter">
            <div className="priceWrapper">
              {strikethrough && <div className="strikethrough">{strikethrough}</div>}
              <div className="price">{products[packageId]}</div>
            </div>
            <div className="arrow">{Arrow()}</div>
          </div>
        </div>
      </Link>
    );
  };

  render() {
    return (
      <span>
        <div className="details">
          <div className="detailsSection">
            <h2 className="iconHeader">
              <IonIcon name="heart-sharp" className="ion-icon" />
              {i18next.t('renewMembership.title')}
            </h2>
            <p> {i18next.t('renewMembership.text')}</p>
          </div>
          <div className="packages">
            {this.renderPackage(3)}
            {this.renderPackage(7, 'color-1')}
            {this.renderPackage(4, 'color-2')}
          </div>
        </div>
      </span>
    );
  }
}
SubscriptionDetails.propTypes = {
  userId: PropTypes.string.isRequired,
};
export default SubscriptionDetails;
